export default __webpack_public_path__ + "static/media/mlc-interior.e6d6ae64.jpeg";